import {
  Calendar,
  Phone,
  MapPin,
  Clock,
  Star,
  Award,
  Heart,
  Shield,
  Building2,
  Package,
  Stethoscope,
  PlusCircle,
  Baby,
  Bone,
  Brain,
  Microscope,
  ChevronRight,
  Download,
  CheckCircle,
  Trophy,
  BadgeIcon as Certificate,
  User,
  ArrowRight,
} from "lucide-react"

import { ServiceCard } from "../service-card"
import { Link } from "react-router-dom"
import { Button } from "../ui/button"
import { Badge } from "../ui/badge"



export default function OurSpecialtieswidget() {
  return (
      <section className="py-12 bg-white">
          <div className="container px-4 mx-auto">
            <div className="flex flex-col items-center mb-10 text-center">
              <Badge className="mb-2">Our Specialties</Badge>
              <h2 className="mb-4 text-3xl font-bold md:text-4xl">Comprehensive Healthcare Services</h2>
              <p className="max-w-2xl text-muted-foreground">
                We offer a wide range of medical services across various specialties to address all your healthcare
                needs.
              </p>
            </div>

            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
              <ServiceCard
                icon={<Heart className="w-10 h-10 text-primary" />}
                title="Cardiology"
                description="Comprehensive heart care with advanced diagnostic and treatment options."
                href="/services/cardiology"
              />
              <ServiceCard
                icon={<Brain className="w-10 h-10 text-primary" />}
                title="Neurology"
                description="Expert care for conditions affecting the brain, spine, and nervous system."
                href="/services/neurology"
              />
              <ServiceCard
                icon={<Bone className="w-10 h-10 text-primary" />}
                title="Orthopedics"
                description="Specialized treatment for bone, joint, and muscle conditions."
                href="/services/orthopedics"
              />
              <ServiceCard
                icon={<Baby className="w-10 h-10 text-primary" />}
                title="Pediatrics"
                description="Compassionate healthcare for infants, children, and adolescents."
                href="/services/pediatrics"
              />
            </div>

            <div className="flex justify-center mt-8">
              <Button
                variant="outline"
                className="gap-2 border-primary text-primary hover:bg-primary hover:text-white"
                asChild
              >
                <Link to="/services">
                  View All Specialties
                  <ChevronRight className="w-4 h-4" />
                </Link>
              </Button>
            </div>
          </div>
        </section>
  );
}

 